import { render, staticRenderFns } from "./OrderLine.vue?vue&type=template&id=b497e6b2&scoped=true"
import script from "./OrderLine.vue?vue&type=script&lang=js"
export * from "./OrderLine.vue?vue&type=script&lang=js"
import style0 from "./OrderLine.vue?vue&type=style&index=0&id=b497e6b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b497e6b2",
  null
  
)

export default component.exports